const JWT_KEY = "banking_jwt" as string;
const JWT_ADMIN_RESERVE_KEY = "banking_admin_reserve_jwt" as string;

import { BearerToken } from "@/core/services/api/interfaces/auth/BearerToken";

/**
 * @description get token form localStorage
 */
export const getToken = (key?: string | null): BearerToken | null => {
  const keyName = key || JWT_KEY;
  const token = window.localStorage.getItem(keyName);
  if (!token || "undefined" === token) {
    return null;
  }
  const parsed = JSON.parse(token);
  if (!parsed || !("access_token" in parsed)) {
    return null;
  }
  const { access_token, expires_in, expires_at, expires_date, token_type } =
    parsed;

  return new BearerToken(
    access_token,
    expires_in,
    expires_at,
    expires_date,
    token_type
  );
};

/**
 * @description clone current token as admin reserve token
 */
export const saveAdminToken = (token: BearerToken): void => {
  window.localStorage.setItem(JWT_ADMIN_RESERVE_KEY, JSON.stringify(token));
};

/**
 * @description retrieve reserved admin token from storage
 */
export const getAdminToken = (): BearerToken | null => {
  return getToken(JWT_ADMIN_RESERVE_KEY);
};

/**
 * @description retrieve reserved admin token from storage
 */
export const destroyAdminToken = (): void => {
  destroyToken(JWT_ADMIN_RESERVE_KEY);
};

/**
 * @description save token into localStorage
 */
export const saveToken = (token: BearerToken): void => {
  window.localStorage.setItem(JWT_KEY, JSON.stringify(token));
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (key: string = JWT_KEY): void => {
  window.localStorage.removeItem(key);
};

export default {
  getToken,
  saveToken,
  destroyToken,
  saveAdminToken,
  getAdminToken,
  destroyAdminToken,
};
